import { render, staticRenderFns } from "./course-advisory.vue?vue&type=template&id=3b971a51&scoped=true&"
import script from "./course-advisory.vue?vue&type=script&lang=js&"
export * from "./course-advisory.vue?vue&type=script&lang=js&"
import style0 from "./course-advisory.vue?vue&type=style&index=0&id=3b971a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b971a51",
  null
  
)

export default component.exports